module.exports = __webpack_public_path__ + "static/logo-white-cc6b408df0c993303b71026ab1676638.png";